import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { Col, Row, Badge } from 'reactstrap'
import { Divider, Empty, message, Popconfirm, Table, Tooltip } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faDownload, faEdit, faSearch, faToggleOff, faToggleOn, faTrash } from '@fortawesome/free-solid-svg-icons'
import moment from 'moment'

import EditDocumentModal from './EditDocumentModal'

import Pagination from '../../../components/Pagination'

import { deleteDocument, updateDocument } from '../services'
import { handleError } from '../../../helpers'

export default function DocumentsTable({ documents, reload, pagination, setPagination }) {
	const [editModal, setEditModal] = useState(null)
	
	const columns = [
		{
			title: 'Título',
			dataIndex: 'title',
			render: (t,r) => <Link to={`/documents/${r.id}`}>{t}</Link>
		},
		{
			title: 'Palabras Clave',
			dataIndex: 'keywords',
		},
		{
			title: 'Estado',
			dataIndex: 'disabled_at',
			render: t => t ? <Badge color='danger'>Oculto</Badge> : <Badge color="success">Visible</Badge>,
		},
		{
			title: 'Acciones',
			render: (t,r) => (
				<React.Fragment>
					<Tooltip title="Ver Perfil">
						<Link to={`/documents/${r.id}`}>
							<FontAwesomeIcon 
								className="text-link" 
								icon={faSearch}
							/>{" "}
							<span className='text-link'>Ver Perfil</span>	
						</Link>
					</Tooltip>
					<Divider type='vertical' />
					<Tooltip title="Descargar">
						<a href={`${r.url}`} target="_blank" rel="noopener noreferrer">
							<FontAwesomeIcon 
								className="text-link" 
								icon={faDownload}
							/>{" "}
							<span className='text-link'>Descargar</span>	
						</a>
					</Tooltip>
					<Divider type='vertical' />
					<Tooltip title={r.disabled_at ? 'Habilitar' : 'Ocultar'} onClick={()=>handleToggle(r)}>
						<FontAwesomeIcon 
							className="text-link" 
							icon={r.disabled_at ? faToggleOff : faToggleOn}
						/>{" "}
						<span className='text-link'>{r.disabled_at ? 'Habilitar' : 'Ocultar'}</span>
					</Tooltip>
					<Divider type='vertical' />
					<Tooltip title="Editar" onClick={()=>setEditModal(r)} >
						<FontAwesomeIcon 
							className="text-link" 
							icon={faEdit}
						/>{" "}
						<span className='text-link'>Editar</span>
					</Tooltip>
					<Divider type='vertical' />
					<Tooltip title="Eliminar">
						<Popconfirm
							title="Esta acción no puede ser revertida"
							okText="Eliminar"
							cancelText="Cancelar"
							onConfirm={() => handleDelete(r.id)}
							okButtonProps={{ danger:true }}
						>
							<FontAwesomeIcon className="text-link" icon={faTrash} />{" "}
							<span className='text-link'>Eliminar</span>
						</Popconfirm>
					</Tooltip>
				</React.Fragment>
			)
		}
	]

	const handleToggle = document => {
		updateDocument(document.id, { disabled_at: document.disabled_at ? null : moment().format('YYYY-MM-DD HH:mm:ss') })
			.then(res => {
				message.success(res.data.message)
				reload()
			})
			.catch(error => handleError(error))
	}

	const handleDelete = id => {
		deleteDocument(id)
			.then(res => {
				message.success(res.data.message)
				reload()
			})
			.catch(error => handleError(error))
	}

	const expandedRowRender = r => (
		<React.Fragment>
			<Row>
				<Col>
					<p className='mb-2'>
						<strong>Categorias: </strong>
						{r.categories.length > 0 ? r.categories.map(c => `${c.name} | `) : <em className='hint-text'>Sin categorías</em>}
					</p>
				</Col>
			</Row>
			<p className='mb-2'><strong>Palabras Clave: </strong>{r.keywords}</p>
		</React.Fragment>
	)
	
	return (
		<React.Fragment>
			<Table 
				dataSource={documents}
				rowKey={r => r.id}
				pagination={false}
				columns={columns}
				size="small"
				expandable={{ expandedRowRender }}
				locale={{ emptyText: (
					<Empty
						description="No se encontraron registros" 
						imageStyle={{ height: '80px' }}
					/> 
				)}}
			/>
			<Pagination 
				pagination={pagination}
				updatePagination={setPagination}
				reload={reload}
			/>
			{ editModal && (
				<EditDocumentModal 
					visible
					onClose={() => setEditModal(null)}
					reload={() => {
						reload()
						setEditModal(null)
					}}
					document={editModal}
				/>
			)}
		</React.Fragment>
	)
}